<template>
  <figure class="absolute mb-16">
    <lottie-player
      id="gears-animation"
      class="gears-animation"
      mode="bounce"
      src="https://assets6.lottiefiles.com/packages/lf20_yh44ygoj.json"
      background="transparent"
      speed="1"
      loop
      autoplay
    ></lottie-player>
  </figure>
</template>

<script>
import { mapGetters } from "vuex";
import { gsap } from "gsap";

export default {
  computed: {
    ...mapGetters({ isLoading: "loader/isLoading" }),
  },
  watch: {
    isLoading(newValue) {
      if (!newValue) {
        this.runLogoIntro();
      }
    },
  },
  methods: {
    runLogoIntro() {
      gsap.from("#gears-animation", {
        opacity: "0",
        scale: "5",
        ease: "power3.inOut",
        duration: 4,
      });
    },
  },
};
</script>

<style lang="postcss" scoped>
.gears-animation {
  position: relative;
  height: auto;
  opacity: 0.6;
  width: 60vw;
}

@media screen and (max-width: 1100px) {
  .gears-animation {
    top: 0;
    width: 80vw;
    left: 5vw;
  }
}

@media screen and (max-width: 800px) {
  .gears-animation {
    top: 0;
    width: 120vw;
    left: 5vw;
  }
}
</style>